import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions(
    'FETCH_PAYMENT_SETUP_SUMMARY',
);
export const fetchPaymentSetupSummary = dataModuleActions.dataRequest;
export const fetchPaymentSetupSummarySuccess = dataModuleActions.dataSuccess;
export const fetchPaymentSetupSummaryError = dataModuleActions.dataError;
export const fetchPaymentSetupSummaryReset = dataModuleActions.dataReset;
